<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M11 0C13.7614 0 16 2.23858 16 5V14H13C9.13401 14 6 10.866 6 7V5C6 2.23858 8.23858 0 11 0ZM7.5 7V5.5H11C11.8284 5.5 12.5 6.17157 12.5 7V12.4776C9.69675 12.225 7.5 9.86902 7.5 7Z"
        fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M21.8389 20.5C21.1522 17.3548 18.3511 15 15 15H7C3.64888 15 0.84776 17.3548 0.16109 20.5C0.055588 20.9832 0 21.4851 0 22H22C22 21.4851 21.9444 20.9832 21.8389 20.5Z"
        fill="currentColor" />
</svg>